import React from 'react';
import GovernmentInsuranceNotice from './GovernmentInsuranceNotice';

import { HeaderStore, userSelector, LOGIN_STATE } from '@zocdoc/components/src/Layout';

export default class GovernmentInsuranceNoticeContainer extends React.PureComponent {
    render() {
        const user = userSelector(HeaderStore.getState());
        const isUserLoggedIn = user.login_state === LOGIN_STATE.LoggedIn
            || user.login_state === LOGIN_STATE.SoftLoggedIn;

        return (
            <GovernmentInsuranceNotice
                isUserLoggedIn={isUserLoggedIn}
                {...this.props}
            />
        );
    }
}
